import React, { Component, Fragment } from 'react';

import { Form, FormControl, FormContext } from 'components/form';
import { InputGroup } from 'components/input';
import { Loader } from 'components/loader';
import { Modal } from 'components/modal';
import { I18n, translate } from 'components/translate';
import { isKeyDownEnter, isKeyDownEsc } from 'helpers/Event';
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';
import { UserSegmentationService } from 'modules/userManager';
import PropTypes from 'prop-types';

@translate()
@inject((stores) => ({
  duplicate: stores.UserSegmentationStore.duplicate,
  segmentation: stores.UserSegmentationStore.segmentation,
  segmentationName: stores.UserSegmentationStore.segmentationName
}))
@observer
class NewSegmentationModal extends Component {
  // #region set up
  static propTypes = {
    duplicate: PropTypes.bool,
    segmentation: MobxPropTypes.objectOrObservableObject,
    segmentationName: PropTypes.string,
    t: PropTypes.func
  };

  state = {
    loading: false
  };

  constructor(props) {
    super(props);

    this.onCancel = this.onCancel.bind(this);
    this.onConfirm = this.onConfirm.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  componentDidMount() {
    const { duplicate, segmentation, t } = this.props;
    const segmentationName =
      duplicate && segmentation.name
        ? `${t('general.copy_of')} ${segmentation.name}`
        : '';

    UserSegmentationService.setData({ segmentationName });

    this._input && this._input.focus();
  }
  // #endregion

  // #region handlers
  async onConfirm({ name }) {
    try {
      this.setState({ loading: true });

      const method = this.props.duplicate
        ? 'duplicateSegmentation'
        : 'createEmptySegmentation';

      await UserSegmentationService[method](name);

      this.setState({ loading: false });
      this.onCancel();
    } catch {
      this.setState({ loading: false });
    }
  }

  onCancel = () => {
    UserSegmentationService.closeNewSegmentationModal();
  };

  handleKeyDown(e, submit) {
    if (isKeyDownEnter(e)) {
      submit && submit();
    } else if (isKeyDownEsc(e)) {
      this.onCancel();
    }
  }
  // #endregion

  // #region render
  render() {
    const { loading } = this.state;
    const { segmentationName } = this.props;

    return (
      <Form onSubmit={this.onConfirm} scrollOnError={false}>
        <Modal
          title="users_manager.users_list.header.new_segmentation"
          onClose={this.onCancel}
        >
          <FormContext.Consumer>
            {(context) => (
              <Fragment>
                <Modal.Body>
                  <p className="modal__text">
                    <I18n
                      html
                      label="users_manager.segmentation.new_segmentation_msg"
                    />
                    <br />
                    <I18n html label="general.set_name_to_continue" />
                  </p>

                  <FormControl>
                    <InputGroup
                      autoComplete="off"
                      className="mt__md"
                      handleKeyDown={(e) =>
                        this.handleKeyDown(e, context.submit)
                      }
                      maxLength="50"
                      name="name"
                      placeholder="config_manager.config_data.area_name_placeholder"
                      ref={(node) => (this._input = node)}
                      required
                      value={segmentationName}
                    />
                  </FormControl>
                </Modal.Body>

                <Modal.Footer>
                  <button
                    id="confirm"
                    className="hot-button hot-button--primary hot-button--lg"
                    disabled={context.isFormDisabled}
                    onClick={context.submit}
                  >
                    <I18n label="general.ok" />
                  </button>

                  <button
                    id="cancel"
                    className="hot-button hot-button--secondary hot-button--lg"
                    onClick={this.onCancel}
                  >
                    <I18n label="general.cancel" />
                  </button>
                </Modal.Footer>
              </Fragment>
            )}
          </FormContext.Consumer>

          {loading && <Loader key="loader" mask />}
        </Modal>
      </Form>
    );
  }
  // #endregion
}

export default NewSegmentationModal;
